<template>
  <Form
    :action-type="actionType"
    :subtitle="subtitle"
    :disabled="wasDisabled"
    :fallback-link="fallbackLink"
    :starting-stock-balance="form.balance"
    :form-body="form"
    :show-preloader="isLoadingNow"
    @on-submit="submit"
    @on-edit="setEditMode(true)"
    @on-cancel="setEditMode(false)"
  >
    <template slot="fields">
      <div class="row">
        <div class="col-lg-12">
          <div
            v-for="(value, key, index) in mainLabels"
            :key="index"
            class="col-lg-6 form-group"
          >
            <fieldset>
              <label>
                {{ value }}
                <span
                  v-if="isRequiredField(validationSchema[key])"
                  class="field__label_required"
                  >*</span
                >
              </label>
              <textarea
                v-if="value === 'Текстовое описание'"
                class="form-control"
                :disabled="actionType === 'read'"
                :maxlength="maxLength[key]"
                placeholder="Отсутствует"
                v-model.trim="form[key]"
              />
              <input
                v-else
                class="form-control"
                :name="key"
                :maxlength="maxLength[key]"
                placeholder="Отсутствует"
                :disabled="actionType === 'read'"
                v-model.trim="form[key]"
              />
            </fieldset>
          </div>
        </div>
      </div>
      <Sublist subtitle="Характеристики">
        <template slot="fields">
          <div class="row">
            <div class="col-lg-12">
              <div
                v-for="(value, key, index) in characterLabels"
                :key="index"
                class="col-lg-6 form-group"
              >
                <fieldset>
                  <label>
                    {{ value }}
                    <span
                      v-if="isRequiredField(validationSchema[key])"
                      class="field__label_required"
                      >*</span
                    >
                  </label>
                  <input
                    class="form-control"
                    placeholder="Отсутствует"
                    :name="key"
                    :maxlength="maxLength[key]"
                    :disabled="actionType === 'read'"
                    v-model.trim="form[key]"
                  />
                </fieldset>
              </div>
            </div>
          </div>
        </template>
      </Sublist>
      <div class="col-lg-6">
        <label class="control-label">Изображение</label>
        <ImageInput
          :preview-image="previewImage"
          :only-preview-image="actionType === 'read'"
          @on-select-file="setImage"
          @on-delete="deleteImage"
        />
      </div>
    </template>
  </Form>
</template>

<script>
import { validationMixin } from "vuelidate";
import schemas from "@/stock/validation-schemas";
import { stockComponentService } from "@/stock/api-services";

import Sublist from "@/_shared/features/form/Sublist";
import Form from "@/_shared/widgets/Form";
import ImageInput from "@/_shared/features/form/ImageInput";

import { useForm, useNotification, useImageField } from "@/_shared/mixins";
import { formsFields } from "@/stock/constants";

import { objectHelper } from "@/_shared/utils";
const { createCopy, createFromKeys } = objectHelper;
export default {
  mixins: [
    validationMixin,
    useForm,
    useNotification,
    useImageField,
  ],
  components: {
    Form,
    Sublist,
    ImageInput,
  },
  data() {
    return {
      fallbackLink: "/packages",
      entityName: {
        readonly: "Упаковка",
        modify: "упаковки",
      },
      form: createFromKeys(formsFields.packageItem.labels),
    };
  },
  validations() {
    return {
      form: this.validationSchema,
    };
  },
  async created() {
    const addingFields = createCopy(this.form);
    const callback = stockComponentService.get("packages");
    await this.setFormFields(addingFields, callback).then(() => {
      this.checkPreviewImageExistence();
    });
  },
  computed: {
    maxLength() {
      return formsFields.packageItem.maxlength;
    },
    validationSchema() {
      return schemas.packageItem;
    },
    mainLabels() {
      const { name, type, barcode, vendor_code, text_description } =
        formsFields.packageItem.labels;
      return {
        name,
        type,
        barcode,
        vendor_code,
        text_description,
      };
    },
    characterLabels() {
      const { color, length, width, height } = formsFields.packageItem.labels;
      return { color, length, width, height };
    },
  },
  methods: {
    async submit() {
      const callback = async () => {
        return await this.prepareImage(false)
          .then(async (image) => {
            return await stockComponentService[this.actionType](
              this.form, "package", image,
            );
          })
          .catch((error) => {
            throw new Error(error.message);
          });
      };
      await this.sendForm(callback);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/stock/pages/PackageForm.vue